import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbFieldType, NbRatingShape} from "./nbinput.entity";


@Component({
  selector: 'nbinput-rating',
  template: require('./nbinput-rating.component.html'),
  styles: [require('./nbinput-rating.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputRatingComponent),
      multi: true
    }
  ]
})

export class NbinputRatingComponent implements ControlValueAccessor{
  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};
  registerOnChange(fn: any): void {if(fn)this.onChangeCallback = fn;}
  registerOnTouched(fn: any): void {if(fn)this.onTouchedCallback = fn;}
  setDisabledState?(isDisabled: boolean): void {this.disabled = isDisabled}
  writeValue(obj: number): void {
    if (this.data != obj) {
      this.data = obj;
    }
  }
  onBlur() {
    this.onTouchedCallback();
  }

  public _shape = ['fa-star','fa-star-o'];
  @Input()
  set shape(v:NbRatingShape){
    this._shape[0] = 'fa-'+v;
    this._shape[1] = 'fa-'+v+'-o';
  }

  set value(v:number){
    if (v != this.data){
      this.data = v;
      this.onChangeCallback(this.isNumeric(v)||v<0?v:0);
    }
  }
  get value(){
    return this.data;
  }
  _data:number = 3;
  @Input()
  set data(v:number){
    this._data = this.isNumeric(v)||v<0?v:0;
    if (this._data>0){
      this.full.fill(1,0,this._data);
    } else {
      this.full.fill(0);
    }

  }
  get data(){
    return this._data;
  }
  _max:number = 5;
  @Input()
  set max(v:number){
    if (v && this.isNumeric(v)){
      this._max = v;
      this.full = Array(v).fill(0);
      this.full.fill(1,0,this._data);
    }
  }
  get max(){
    return this._max;
  }
  public full: Array<number> = [];

  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  @Input()
  public disabled:boolean;
  changeData(i){
    if (!this.disabled){
      this.data = i+1;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/nbinput/nbinput-rating.component.ts